/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import loader from '../assets/img/loader.gif';

function Loader({style}) {
  return (
    <img src={loader} style={style} alt="loading .." />
  )
}

Loader.propTypes = {
style:PropTypes.object,

}
Loader.defaultProps = {
  style:{width:'2em',height:'2em'},

}
export default Loader

